import { render, staticRenderFns } from "./Partidas.vue?vue&type=template&id=1f21baf3"
import script from "./Partidas.vue?vue&type=script&lang=js"
export * from "./Partidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports